<template>
  <div
    class="wrapper d-flex align-items-center"
    :class="{ 'emoji-picker-shown': emojiPickerOpened }"
  >
    <post-reaction-icon
      class="icon-wrapper post-reaction flex-center"
      :event="event"
      @ep-shown="emojiPickerOpened = true"
      @ep-hidden="emojiPickerOpened = false"
      @reacted="$emit('reacted', $event)"
    />
    <give-award-icon
      v-if="isAwardable"
      class="award-icon-wrapper icon-wrapper flex-center"
      :context="awardContext"
      :team-id="teamId"
      variant="secondary"
      @awarded="$emit('awarded')"
    />
  </div>
</template>

<script>
import GiveAwardIcon from '@/components/award/GiveAwardIcon'
import PostReactionIcon from '@/components/reactions/PostReactionIcon'
import { ENTITY_TYPE } from '@/constants/entities'
import { INITIATIVE_EVENT_TYPE, INITIATIVE_FIELDS } from '@/constants/initiative'
import getEventAwardContext from '@/utils/getEventAwardContext'

/**
 * This controls following actions on Initiative Event
 * - award
 * - reaction
 *
 * @emits
 * - awarded
 * - reacted
 */
export default {
  name: 'InitiativeEventActions',
  props: ['event', 'initiative'],
  components: {
    PostReactionIcon,
    GiveAwardIcon
  },
  data() {
    return {
      emojiPickerOpened: false
    }
  },
  computed: {
    isStatusChangeEvent() {
      return (
        this.event.type === INITIATIVE_EVENT_TYPE.FIELD_CHANGED &&
        this.event.field === INITIATIVE_FIELDS.STATUS.id
      )
    },
    isCommentEvent() {
      return this.event.type === INITIATIVE_EVENT_TYPE.COMMENT
    },
    awardContext() {
      if (this.isAwardable) {
        const context = getEventAwardContext(
          this.event,
          ENTITY_TYPE.INITIATIVE,
          this.initiative.title
        )
        return { ...context, initiativeId: this.initiative.id }
      }
      return {}
    },
    teamId() {
      const goalId = this.initiative.goalId
      const goal = this.$store.getters.goalById(goalId)
      return goal?.teamId
    },
    isAwardable() {
      return this.isStatusChangeEvent || this.isCommentEvent
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.wrapper {
  box-shadow: 0 1px 1px $tertiary;
  border-radius: 5px;
  border: 1px solid $borderPrimary;
}

.emoji-picker-shown {
  opacity: 1 !important;
}

.icon-wrapper {
  width: 25px;
}

.post-reaction {
  border-right: 1px solid $borderSecondary;
}
</style>
